import { SET_CURRENT_USER } from './types';

export function setCurrentUser(currentUser) {
	return {
		type: SET_CURRENT_USER,
		user: currentUser
	}
}